<div class="wo-icon-field">
  <iss-icon class="wo-icon-field__icon" [name]="icon" />
  <div><ng-content/></div>
</div>
